import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import { Typography } from 'builder/styles/typography'

export const Wrapper = styled.div`
  position: relative;
  ${Typography.Body};
  border-radius: 8px;
`

export const Label = styled.label`
  ${Typography.Caption};
  color: ${Colors.Neutral50};
  display: block;
  margin-bottom: 6px;
`
